export default function routing($stateProvider) {

    $stateProvider.state('event', {
            url: "/event",
            abstract: true
        })

        .state('event.index', {
            url: "",
            controller: 'EventCtrl',
            controllerAs: 'index',
            template: require('../../../views/event/index.html'),
            ncyBreadcrumb: {
                label: 'BREADCRUMBS:EVENT:INDEX'
            }
        })

        .state('event.folder', {
            url: "/{folder}",
            controller: 'EventCtrl',
            controllerAs: 'index',
            template: require('../../../views/event/index.html'),
            ncyBreadcrumb: {
                parent: 'event.index',
                skip: true
            }
        })

        .state('event.show', {
            url: "/{id}/show",
            controller: 'EventShowCtrl',
            controllerAs: 'show',
            template: require('../../../views/event/show.html'),
            params: { eventSubscribersStatus: 'attending' },
            ncyBreadcrumb: {
                parent: 'event.folder',
                label: 'BREADCRUMBS:CAMPAIGN:SHOW'
            }
        })

        .state('event.exportAttending', {
            url: "/{id}/export/{tagId}",
            controller: 'TagExportCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/tag/export.html'),
            params: {
                eventSubscribersStatus: 'attending',
                exportId: null
            },
            ncyBreadcrumb: {
                parent: 'event.show',
                label: 'BREADCRUMBS:EVENT:EXPORT'
            }
        })

        .state('event.editCampaign', {
            url: "/{eventId}/{type}/{dispatcherId}/edit",
            controller: 'EventMessageCtrl',
            controllerAs: 'edit',
            template: require('../../../views/event/edit.html'),
            ncyBreadcrumb: {
                parent: 'event.folder',
                label: 'BREADCRUMBS:EDIT'
            }
        })

        .state('event.editAutomation', {
            url: "/{eventId}/{type}/{dispatcherId}/email/{emailId}/edit",
            controller: 'EventMessageCtrl',
            controllerAs: 'edit',
            template: require('../../../views/event/edit.html'),
            ncyBreadcrumb: {
                parent: 'event.folder',
                label: 'BREADCRUMBS:EDIT'
            }
        })

        .state('event.editPage', {
            url: "/{id}/page/{type}",
            controller: 'EventPageCtrl',
            controllerAs: 'page',
            template: require('../../../views/event/page.html'),
            ncyBreadcrumb: {
                parent: 'event.folder',
                label: 'BREADCRUMBS:EDIT'
            }
        })

        .state('event.campaignStatistics', {
            url: "/{eventId}/campaign/{id}/statistics/{folder}",
            controller: 'StatisticsCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/statistic/statistics.html'),
            ncyBreadcrumb: {
                parent: 'event.folder',
                label: 'BREADCRUMBS:EVENT:CAMPAIGN_STATISTICS'
            }
        })

        .state('event.automationStatistics', {
            url: "/{eventId}/automation/{id}/statistics/{folder}",
            controller: 'StatisticsCtrl',
            controllerAs: 'ctrl',
            template: require('../../../views/statistic/statistics.html'),
            ncyBreadcrumb: {
                parent: 'event.folder',
                label: 'BREADCRUMBS:EVENT:AUTOMATION_STATISTICS'
            }
        });
}

routing.$inject = ['$stateProvider'];

